import React from 'react'
import { Link } from 'react-router-dom'
import { BsGithub } from 'react-icons/bs';
import { BsInstagram } from 'react-icons/bs';
import { BsTwitter } from 'react-icons/bs';
import { motion } from "framer-motion";
import image from '../assets/cov.jpg'
import Tesmonials from './Tesmonials';

function content() {
  return (
    <>
   
    <motion.div className='flex flex-col-reverse sm:flex-row  mt-20 items-center justify-between '
    initial={{y:100}}
    animate={{y:0}}>


      {/* left side  */}

      <div className='text-center lg:text-start md:text-start '>
        
          <div className=' space-y-6   '>
             <h1 className='font-bold text-gray-800 text-3xl'>Mahaer</h1>
              <p className=' text-gray-500 text-xl'>
            “Responsive Web Design always plays an <br />
            important role whenever going to promote your website.”
            </p>
            {/* social links */}
            <div className=' flex space-x-4 justify-center lg:justify-start md:justify-start ' >
            <h1  className=' cursor-pointer text-2xl transition-all hover:text-blue-700 ' >
            <Link  to='www.https://github.com/Khadar-abdi'> <BsGithub /></Link> 
            
          </h1>
          <h1  className=' cursor-pointer text-2xl transition-all hover:text-blue-700 ' >
            <Link  to='www.https://instagram.com/Khadar-abdi'> <BsInstagram /></Link> 
            
          </h1>
          <h1  className=' cursor-pointer text-2xl transition-all hover:text-blue-700 ' >
            <Link  to='www.https://Twitter.com/Khadar-abdi'> <BsTwitter /></Link> 
            
          </h1>
         </div>
          
         
          <br />
        
          </div>
          <button className='bg-gray-300  font-sans  sm:items-center  rounded-lg hover:-translate-y-1 duration-100 hover:text-gray-500 font-medium   p-1.5 '>
            <a href="https://drive.google.com/file/d/1TMRIP_bDtvg5f-vHfjPHtzvcLAlL3A3o/view?usp=share_link" download={true} > Download resume</a>
          </button>
       
        


      </div>

      {/* right side  */}

      <div >
        <div className='w-80 mb-10 sm:m-0 hover:-translate-y-4 hover:-translate-x-2 duration-1000'>
          <img src={image} className='rounded-full   object-cover ' alt="" />
        </div >

      </div>


    </motion.div>
    <Tesmonials/>
    </>
  );
}

export default content
